import api, { setToken } from '../index';

export function getHomework(data) {
  return (api.post('/schedule/homework', { event_id: data.event_id, homework_id: data.homework_id }, setToken(data.token)));
}